import React, { useEffect } from 'react';

const KeyboardShortcuts = ({ shortcuts = [], disabled = false }) => {
  useEffect(() => {
    const handleKeyDown = event => {
      if (disabled) return;

      // Check for Ctrl/Cmd key combinations
      if (event.ctrlKey || event.metaKey) {
        const shortcut = shortcuts.find(s => s.key.toLowerCase() === event.key.toLowerCase());

        if (shortcut) {
          event.preventDefault();

          // Check if the shortcut has additional conditions
          if (shortcut.condition && !shortcut.condition()) {
            return;
          }

          // Execute the callback
          if (shortcut.callback) {
            shortcut.callback();
          }
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [shortcuts, disabled]);

  // This component doesn't render anything
  return null;
};

export default KeyboardShortcuts;
